module.exports = __webpack_public_path__ + "static/media/Sketch9.fcdf066e.jpg";